exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3LDTTSDmhdmBQX{font-size:12px;display:block;text-align:center;color:#5e6c84;margin-top:4px}", ""]);

// exports
exports.locals = {
	"feedback": "_3LDTTSDmhdmBQX"
};